"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUserstate2 = exports.defaultUserstate = void 0;
var LoginState_1 = require("@/pages/common/states/LoginState");
exports.defaultUserstate = {
    id: '',
    email: '',
    firstname: '',
    lastname: '',
    salutation: LoginState_1.Salutation.NONE,
    phone: '',
    subscribed: true,
    from: '',
    isConfirmed: false,
    countryCode: ''
};
exports.defaultUserstate2 = {
    id: 'dasdasdas',
    email: 'roy.cheung@okay.com',
    firstname: '',
    lastname: '',
    salutation: LoginState_1.Salutation.NONE,
    phone: '',
    subscribed: false,
    from: '',
    isConfirmed: false,
    countryCode: ''
};
